import React, { useState, useMemo, useEffect } from "react";

import { ApiService } from "../../utils/ApiService";
import Pagination from "../../common/Pagination";
import { Avatar, formatDateTime } from "../../common/Functions";
import SearchComponent from "../../components/SearchComponent";
import { showToast } from "../../common/Toast";
import HostDashboard from "../HostDetail";
import FullPageLoader from "../../common/FullPageLoader";

const ContactUs = () => {
  const [contactUsList, setContactUsList] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [pagination, setPagination] = useState({});
  const [selectedMessage, setSelectedMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchContactUsList(page, limit);
  }, []);

  const fetchContactUsList = async (currentPage, currentLimit, search) => {
    const params = {
      page: currentPage,
      limit: currentLimit,
    };
    if (search) {
      params.keyword = search;
    }
    try {
      setLoading(true);
      const queryString = new URLSearchParams(params).toString();
      const res = await ApiService.get(`admin/contact-us-list?${queryString}`);
      if (res.success) {
        setContactUsList(res.contactUs || []);
        setPagination(res.pagination);
      }
    } catch (error) {
      console.log("host error", error);
    } finally {
      setLoading(false);
    }
  };

  // Toggle Status

  const handlePagination = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      setPage(newPage);
      fetchContactUsList(newPage, limit, search);
    }
  };
  const handleSearch = (e) => {
    const value = e.target.value;
    if (value.startsWith(" ")) return;
    setSearch(value);
    setPage(1);
    fetchContactUsList(1, limit, e.target.value);
  };

  const startingIndex = (page - 1) * limit;
  return (
    <>
      {loading && <FullPageLoader />}
      <div className="flex-grow bg-gray-100  px-6 w-full overflow-auto h-[90vh]">
        {
          <div className="mb-6">
            <SearchComponent
              search={search}
              onChange={handleSearch}
              placeholder="Search by name, email...."
            />
          </div>
        }
        <>
          <div className="bg-white shadow rounded-2xl overflow-hidden mt-2">
            <table className="w-full text-center">
              <thead className="bg-gray-200 text-m text-black">
                <tr>
                  <th className="p-4 text-left font-normal">S.No</th>
                  <th className="p-4 text-left font-normal">Date & Time</th>{" "}
                  {/* <-- left aligned header */}
                  <th className="p-4 text-left font-normal">Name</th>
                  <th className="p-4 text-left font-normal">Email</th>
                  <th className="p-4 text-left font-normal"> Message</th>
                </tr>
              </thead>

              {/* Table body */}
              <tbody>
                {contactUsList.map((contactList, index) => (
                  <tr
                    key={contactList._id}
                    className="border-t hover:bg-gray-50 cursor-pointer"
                  >
                    <td className="p-5 text-left text-[#4C4C4C] font-normal text-sm">
                      {String(startingIndex + index + 1).padStart(2, "0")}
                    </td>

                    <td className="p-5 text-left text-[#4C4C4C] font-normal text-sm">
                      {formatDateTime(contactList.createdAt) || "--"}
                    </td>
                    <td className="p-5 text-left text-[#4C4C4C] font-normal text-sm">
                      <div className="flex items-center gap-4">
                        <Avatar
                          name={contactList.name}
                          image={contactList.image}
                          size={32}
                        />

                        {/* Name text */}
                        <div className="text-sm font-medium text-gray-800 whitespace-nowrap">
                          {contactList.name}
                        </div>
                      </div>
                    </td>

                    <td className="p-5 text-left text-[#4C4C4C] font-normal text-sm">
                      {contactList.email}
                    </td>
                    <td className="p-5 text-left text-[#4C4C4C] font-normal text-sm">
                      {contactList.message.length > 30 ? (
                        <>
                          {contactList.message.substring(0, 25)}...
                          <button
                            className="text-blue-600 ml-1 underline"
                            onClick={() => {
                              setSelectedMessage(contactList.message);
                              setShowModal(true);
                            }}
                          >
                            Read More
                          </button>
                        </>
                      ) : (
                        contactList.message
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {contactUsList.length === 0 && (
              <p className="text-center py-10 text-gray-500">
                No results found
              </p>
            )}
          </div>
          <Pagination
            page={page}
            totalPages={pagination.totalPages}
            totalItems={pagination.totalContactUs}
            limit={limit}
            onPageChange={(newPage) => handlePagination(newPage)}
          />
          {showModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white rounded-lg p-6 w-[500px] max-w-full shadow-xl">
                <h2 className="text-lg font-semibold mb-4">Message</h2>
                <p className="text-gray-700">{selectedMessage}</p>

                <button
                  onClick={() => setShowModal(false)}
                  className="mt-4 px-3 py-1 text-white rounded-md transition-all duration-200 bg-[rgb(139_115_85)] hover:bg-[rgb(120_98_70)]"
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </>
      </div>
    </>
  );
};

export default ContactUs;
